import { render, staticRenderFns } from "./WBtnUnarchive.vue?vue&type=template&id=7f670110&scoped=true&"
import script from "./WBtnUnarchive.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnUnarchive.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f670110",
  null
  
)

export default component.exports